'use strict';
exports.default = exports;
const _ = require('lodash');
const moment = require('moment');
const StringUtils = require('../common/StringUtils');

exports.batch2algolia = async (id, obj) => {
  const out = {
    objectID: id,
    id: id,
    active: Boolean(obj.active),
    name: obj.name || '',
    healthInsuranceName: obj.healthInsuranceName || '',
    healthInsuranceId: obj.healthInsuranceId || '',
    companyId: obj.companyId || '',
    code: obj.code || '',
    sequencialTransacao: obj.sequencialTransacao || '',

    dateIsoYearMonth: obj.dateIsoYearMonth || '',
    dateIso: obj.dateIso || '',
    countEvents: obj.countEvents || 0,
  };
  return out;
};

exports.user2algolia = async (id, obj) => {
  const out = {
    objectID: id,
    id: id,
    name: obj.name,
    lastName: obj.lastName,
    email: obj.email,
  };
  if(obj.address && obj.address.latitude && obj.address.longitude) {
    out._geoloc = {
      lat: obj.address.latitude,
      lng: obj.address.longitude
    };
  }
  return out;
};

exports.healthInsuranceResume = (obj) => {
  const out = {
    id: obj?.id || '',
    name: obj?.name || '',
    cnpj: obj?.cnpj || ''
  };
  return out;
};

exports.companyResume = (obj) => {
  const out = {
    id: obj?.id || '',
    name: obj?.name || '',
    type: obj?.type || null,
    flags: {
      isPersonalProduction: obj?.flags?.isPersonalProduction || false,
    },
    cnpj: obj?.cnpj || ''
  };
  return out;
};

exports.anesthetistResume = (obj) => {
  const out = {
    id: obj?.id || '',
    name: obj?.name || '',
  };
  return out;
};
exports.hospitalResume = (obj) => {
  const out = {
    id: obj?.id || '',
    name: obj?.name || '',
    cnpj: obj?.cnpj || ''
  };
  return out;
};

exports.userResume = (obj) => {
  const out = {
    id: obj?.id || '',
    name: obj?.name || '',
  };
  return out;
};

exports.patient2algolia = async (id, obj) => {
  const out = {
    objectID: id,
    id: id,
    documentId: id,
    name: obj.name || '',
    active: obj.active || false,
    birthDateIso: obj.birthDateIso || '',
    companyId: obj.companyId || null,
    companyIds: obj.companyIds || null,
    cpf: obj.cpf || '',
    email: obj.email || '',
    gender: obj.gender || '',
    healthInsuranceId: obj.healthInsuranceId || null,
    healthInsuranceWallet: obj.healthInsuranceWallet || '',
    phone: obj.phone || '',
    momName: obj.momName || '',
    profileImgUrl: obj.profileImgUrl || '',
  };
  if(!out.birthDateIso && typeof obj.birthDate?.toDate==='function') {
    const e = moment(obj.birthDate.toDate());
    if(e.isValid()) {
      out.birthDateIso = e.format('YYYY-MM-DD');
    }
  }
  return out;
};

exports.patient2pg = (id, obj) => {
  const out = {
    id: id,
    accomodation: obj.accomodation || null,
    axregId: obj.axregId || null,
    name: obj.name || '',
    nameLowerCase: StringUtils.deburr(obj.nameLowerCase || ''),
    search: StringUtils.deburr(`${obj.name || ''} ${obj.cpf || ''} ${obj.email || ''} ${obj.healthInsuranceWallet || ''}`),
    active: obj.active || false,
    birthDate: obj.birthDate?.toDate()?.toISOString() || null,
    birthDateIso: obj.birthDateIso || '',
    companyId: obj.companyId || null,
    matrizId: obj.matrizId || null,
    companyIds: obj.companyIds || [],
    cpf: obj.cpf || '',
    email: obj.email || '',
    gender: obj.gender || '',
    healthInsuranceId: obj.healthInsuranceId || null,
    healthInsuranceWallet: obj.healthInsuranceWallet || '',
    phone: obj.phone || '',
    momName: obj.momName || '',
    profileImgUrl: obj.profileImgUrl || '',

    createdAt: obj.meta?.createdAt ? moment(obj.meta.createdAt.toDate()).toISOString() : null,
    createdBy: obj.meta?.createdBy,
    createdByName: obj.meta?.createdByName,
    updatedAt: obj.meta?.updatedAt ? moment(obj.meta.updatedAt.toDate()).toISOString() : null,
    updatedBy: obj.meta?.updatedBy || null,
    updatedByName: obj.meta?.updatedByName || null,
    deletedAt: obj.meta?.deletedAt ? moment(obj.meta.deletedAt.toDate()).toISOString() : null,
    deletedBy: obj.meta?.deletedBy || null,
    deletedByName: obj.meta?.deletedByName || null
  };
  if(!out.birthDateIso && typeof obj.birthDate?.toDate==='function') {
    const e = moment(obj.birthDate.toDate());
    if(e.isValid()) {
      out.birthDateIso = e.toISOString();
    }
  }

  if(!out.id || !out.companyId) {
    //invalid data
    return  null;
  }
  if(!out.companyIds?.length) {
    out.companyIds = [out.companyId];
  }
  if(obj.matrizId && !out.companyIds.includes(obj.matrizId)) {
    out.companyIds.push(obj.matrizId);
  }

  return out;
};

exports.structureMeta = (obj) => {
  obj.meta = {
    createdAt: obj?.createdAt ? new Date(obj?.createdAt) || null : null,
    createdBy: obj?.createdBy,
    createdByName: obj?.createdByName,
    updatedAt: obj?.updatedAt ? new Date(obj?.updatedAt) || null : null,
    updatedBy: obj?.updatedBy,
    updatedByName: obj?.updatedByName,
    deletedAt: obj?.deletedAt ? new Date(obj?.deletedAt) || null : null,
    deletedBy: obj?.deletedBy,
    deletedByName: obj?.deletedByName,
  };
  delete obj?.createdAt;
  delete obj?.createdBy;
  delete obj?.createdByName;
  delete obj?.updatedAt;
  delete obj?.updatedBy;
  delete obj?.updatedByName;
  delete obj?.deletedAt;
  delete obj?.deletedBy;
  delete obj?.deletedByName;

  return obj;
};

exports.removeInternalFields = (obj) => {
  for (const field in obj) {
    if(field.startsWith('__')) {
      delete obj[field];  // isso explode com o atributo __typename
    }
  }
  return obj;
};


exports.transaction2pg = (id, obj) => {
  const out = {
    id: id,

    action: obj.action || '',
    anesthetistId: obj.anesthetistId || null,
    batchesIds: !obj.batchesIds?.length  ? undefined : obj.batchesIds,
    canceledById: obj.canceledById || null,
    canceledId: obj.canceledId || null,
    cobrancaId: obj.cobrancaId || null,
    companyId: obj.companyId || null,
    creationDate: moment(obj.creationDate?.toDate())?.toISOString() || null,
    date: moment(obj.date?.toDate())?.toISOString() || null,
    eventId: obj.eventId || null,
    healthInsuranceId: obj.healthInsuranceId || null,
    hospitalId: obj.hospitalId || null,
    isAdditional: obj.isAdditional || false,
    isMatriz: obj.isMatriz || false,
    matrizId: obj.matrizId || null,
    paid: obj.paid || false,
    procedureRowId: obj.procedureRowId || null,
    transferId: obj.transferId || null,
    userId: obj.userId || null,
    userName: obj.userName || null,
    type: obj.type || null,
    value: obj.value ? obj.value : 0.0,

    createdAt: moment(obj.creationDate?.toDate())?.toISOString() || null,
    createdBy: obj.userId || null,
    createdByName: obj.userName || null,
  };

  if(!out.creationDate && out.date) {
    out.creationDate = out.date;
  }
  if(!out.type) {
    out.type = 'PROCEDURE';
  }

  if (!out.id ||
    !out.action || !out.companyId ||
    !out.creationDate || !out.date ||
    !out.userId || !out.userName ||
    !out.type) {
    console.log('invalid data on transaction2pg', obj);
    return null;
  }
  return out;
};

exports.post2algolia = (id, obj) => {
  const out = {
    objectID: id,
    id: id,
    published: obj.published || false,
    name: obj.name || {},
    description: obj.description || {},
    body: obj.body || {},
    seo: obj.seo || {},
    categoriesIds: obj.categoriesIds || '',
    categories: obj.categories || [],
    dateIso: null,
    slug: obj.slug || '',
    images: obj.images || {},
  };
  if(typeof obj.date?.toDate==='function') {
    const e = moment(obj.date.toDate());
    if(e.isValid()) {
      out.dateIso = e.format('YYYY-MM-DD HH:mm:ss');
    }
  }
  return out;
};

exports.postResume = function(id, obj) {
  return {
    id: id,
    name: obj.name || {},
    description: obj.description || {},
    images: {
      main: obj.images?.main || null,
    },
    slug: obj.slug || '',
  };
};
exports.postCategoryResume = function(id, obj) {
  return {
    id: id,
    name: obj.name || {},
    desc: obj.desc || {},
  };
};
exports.postPublisherResume = function(id, obj) {
  return {
    id: id,
    name: obj.name || '',
    images: {
      profile: obj.images?.profile || null,
    },
  };
};

/**
 *
 * @param docId
 * @param before
 * @param after
 */
exports.needUpdateUser = async function(docId, before, after) {
  const p1 = exports.user2algolia(docId, before);
  const p2 = exports.user2algolia(docId, after);
  return !_.isEqual(await p1, await p2);
};

exports.needUpdateProduct = async function(docId, before, after) {
  const p1 = exports.product2algoliaNoCompany(docId, before);
  const p2 = exports.product2algoliaNoCompany(docId, after);
  return !_.isEqual(await p1, await p2);
};


exports.subCategoryResume = async (id, obj) => {
  const _obj = obj || {};
  const out = {
    active: _obj.active || false,
    categoryId: _obj.categoryId || null,
    companyId: _obj.companyId || null,
    description: _obj.description || '',
    imgUrl: _obj.imgUrl || null,
    order: _obj.order || null,
    visible: _obj.visible || null,
  };
  return out;
};

exports.needUpdateSubCategory = async function(docId, before, after) {
  const p1 = exports.subCategoryResume(docId, before);
  const p2 = exports.subCategoryResume(docId, after);
  return !_.isEqual(await p1, await p2);
};

exports.eventResume = async (id, item) => {
  item = item || {};
  item.status = item.status || {};
  item.values = item.values || {};
  item.patient = item.patient || {};
  const ret = {
    id: id,
    axregId: item.axregId || null,
    active: Boolean(item.active),
    createdAt: item.createdAt || null,
    createdEnv: item.createdEnv || null,
    additionalData: item.additionalData || {},

    anesthesiaStart: item.anesthesiaStart || null,
    anesthesiaEnd: item.anesthesiaEnd || null,
    numberProviderGuide: item.additionalData?.numberProviderGuide || null,
    mainName: item.mainName || '',

    accommodation: item.accommodation || null,
    anesthetistId: item.anesthetistId || null,
    secondaryAnesthetistId: item.secondaryAnesthetistId || null,
    healthInsuranceId: item.healthInsuranceId || null,
    surgeonId: item.surgeonId || null,
    hospitalId: item.hospitalId || null,
    companyId: item.companyId || null,
    dtProcedure: item.dtProcedure || null,
    numGuide: item.numGuide || null,
    observation: item.observation || null,
    observationGuideSent: item.observationGuideSent || null,
    observationRecourse: item.observationRecourse || null,
    dtRecourse: item.dtRecourse || null,
    healthInsuranceWallet: item.healthInsuranceWallet || '',
    status_checked: item.status.checked || false,
    status_sent: item.status.sent || false,
    status_finished: item.status.finished || false,
    status_received: item.status.received || false,
    status_recourse: item.status.recourse || false,
    status_recourseSent: item.status.recourseSent || false,
    status_hasComplementation: item.status.hasComplementation || false,
    status_urgent: item.status.urgent || false,
    status_hasLoss: item.status.hasLoss || false,

    values_complementation: item.values.complementation || 0,
    values_complementationReceived: item.values.complementationReceived || 0,
    values_totalLoss: item.values.totalLoss || 0,
    values_totalProcedures: item.values.totalProcedures || 0,
    values_totalReceived: item.values.totalReceived || 0,
    values_total: item.values.total || 0,

    patientId: item.patientId || null,
    patientName: item.patient.name || '',
    patientCpf: item.patient.cpf || '',
    patientNameLowerCase: item.patient.nameLowerCase || '',
  };
  return ret;
};

exports.eventTrResume = async (id, item) => {
  item = item || {};
  return {
    healthInsuranceId: item.healthInsuranceId || null,
    batchesIds: item.batchesIds || null,
    // anesthetistId: item.anesthetistId || null, // TODO Atualizar para os atores
    hospitalId: item.hospitalId || null
  };
};

exports.eventResumeFetched = async (id, item) => {
  item = item || {};
  item.status = item.status || {};
  item.values = item.values || {};
  item.patient = item.patient || {};
  item.meta = item.meta || {};
  const ret = {
    id: id,
    active: Boolean(item.active),
    accommodation: item.accommodation || null,
    anesthetistId: item.anesthetistId || null,
    axregId: item.axregId || null,
    secondaryAnesthetistId: item.secondaryAnesthetistId || null,

    additionalData: item.additionalData || {},
    anesthesiaStart: item.anesthesiaStart || null,
    anesthesiaEnd: item.anesthesiaEnd || null,
    numberProviderGuide: item.additionalData?.numberProviderGuide || null,
    mainName: item.mainName || '',

    healthInsuranceId: item.healthInsuranceId || null,
    negotiationId: item.negotiationId || null,
    surgeonId: item.surgeonId || null,
    residentId: item.residentId || null,
    hospitalId: item.hospitalId || null,
    companyId: item.companyId || null,
    dtProcedure: item.dtProcedure || null,
    dtRecourse: item.dtRecourse || null,
    healthInsuranceWallet: item.healthInsuranceWallet || '',
    patientId: item.patientId || null,
    matrizId: item.matrizId || null,
    invoicesIds: item.invoicesIds || [],
    batchesIds: item.batchesIds || [],
    status: item.status || {},
    values: item.values || {},
    isEmergency: Boolean(item.isEmergency),
    type: item.type || null,
    patient: {
      name: item.patient.name || '',
      cpf: item.patient.cpf || '',
    },
    hasObservations: Boolean((item.observations||{}).length),
    formResponseId: item.formResponseId || null,
    formResponseIds: item.formResponseIds || [],
    proceduresIdProcs: item?.procedures?.map((a)=>(a.idProc ||'')) || [],

    //Contrato
    contractId: item.contractId || null,
    contractNumber: item.contractNumber || null,
    notValued: item.notValued || null,

    //Conta Azul
    contaAzulId: item.contaAzulId || null,
  };

  ret.invoices = (item.invoices || []).map((a)=>{return {code: a.code || ''};});
  ret.batches = (item.batches || []).map((a)=>{return {code: a.code || '', name: a.name};});
  return ret;
};

















